import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Collapse, ConfigProvider, DatePicker, Input, Radio, Select, Skeleton, Space, Spin, Tag } from "antd";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect"
import { calculateDateRangeFromDate } from "../../../../../../Utils//DateConverstion";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { ElectricalMeterGrid } from "./ElectricalMeterGrid";
import { useDispatch, useSelector } from "react-redux";
// import TreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import SteamTreeSelectCustom from "../../../../../Elements/TreeSelect/TreeSelectCustom";
import {
  EnvironmentOutlined,
  FilterOutlined,
   } from "@ant-design/icons";
   import {SunOutlined,MoonOutlined} from "@ant-design/icons"; 
import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import { setTheme } from "../../../../../../Store/Reducers/ThemeAction"; 
import { handledarkMode } from "../../../../../Elements/DarkModeAction";
import NotAuthenticated from "../../../../../CommonScreens/NotAuthenicated";
import SteamTreeSelectCustomWithSelectAll from "../LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
   
const MeterStatus = () => { 
   const dispatch =useDispatch()  
  const { makeRequest,screenNameChecker } = useStoreUpdaterWithAPI();  
  const [open, setOpen] = useState(false);
  const [sectionId, setSectionId] = useState(1); 
  const [converterGroupId, setConverterGroupId] = useState(1);
  const [report, setReport] = useState([]);
  const [skip, setSkip] = useState(true);
  // const [selectedMeterIds, setSelectedMeterIds] = useState(['1','3','2','4','5','6']);
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [selectedMeter, setSelectedMeter] = useState([]);
  const [selectedValues, setSelectedValues] = useState([8, 12, 34,15]);
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [paraError, setParaError] = useState("");
  const [meterError, setMeterError] = useState();
  const [submitClicked, setSubmitClicked] = useState(false);
  const [input, setInput] = useState([null]);
  const [flowSectionList, setFlowSectionList] = useState([])
  const [flowConverterList, setFlowConverterList] = useState([])
  const [flowGroupDetailList, setFlowGroupDetailList] = useState([])
  const [nsFlowConverterList, setNsFlowConverterList] = useState([]);
  const [GroupMeterList, setGroupMeterList] = useState([]);
  const [MeterData, setMeterData] = useState([]);
  const [parameterList, setParameterList] = useState([]);
  const [isLoading, setIsLoading] = useState(true)
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
  const showDrawer = () => setOpen(true);
  const onClose = () => setOpen(false);
  const [noData, setNoData] = useState(false);
  const [loadings, setLoadings] = useState(true);
  const defaultParameters = [8, 12, 33, 15];
  const [selected, setSelected] = useState(true);
  const [meterCount, setMeterCount] = useState(0);
  const [count, setCount] = useState(false);  
  const [parameterLenght, setParameterLenght] = useState('')
  const [latestDate, setLatestDate] = useState(null);
  const [defaultLoad,setDefaultLoad]=  useState(true)
  const color = useSelector((state) => state.ThemeChange);
  // //console.log(color)
  // const simulateLoading = (setLoadings) => {
  //   setLoadings(true);
  //   setTimeout(() => {
  //     setLoadings(false);
  //   }, 2000);
  // };
  useEffect(() => {
    startLiveDateLogger()
  }, []);

//   function startLiveDateLogger() {
//   const logTime = () => {
  
//     //console.clear(); // optional: clears previous output
//     setCount(!count)
//     setInputData(); // Fetch meter data every minute
//   };

//   logTime(); // Initial call
//   setInterval(logTime, 60 * 1000); // Update every minute
// }
 const intervalRef = useRef(null);

  const logTime = () => {
    //console.clear(); // optional
    setInputData(); // your data fetching logic
  };

  const startLiveDateLogger = () => {
    logTime(); // Initial call
    intervalRef.current = setInterval(logTime, 60 * 1000); // Every 1 min
  };

  const clearLiveDateLogger = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    if (submitClicked) {
      clearLiveDateLogger(); // Reset old
      startLiveDateLogger(); // Start new
    }

    return () => {
      clearLiveDateLogger(); // Cleanup on unmount
    };
  }, [submitClicked]); // runs when `submit` becomes true
//console.log(count)

  function getLatestDate(data) {
    if (!Array.isArray(data) || data.length === 0) return null;

    return data.reduce((latest, current) => {
      const currentDate = new Date(current.CreatedOn);
      const latestDate = new Date(latest.CreatedOn);
      return currentDate > latestDate ? current : latest;
    });
  }
    
  const fetchMeterLive = (input) => {
    setIsLoading(true);
    // //console.log(input)
    if (input&&input.SectionID&&input.MeterIds?.length&&input.ConverterorGroupID&&!open) {
      makeRequest({
        type: APIConstants.GET,
        // SectionID=1&ConverterorGroupID=1&MeterIds=1&Parameters=1&FromDate=11-13-2024&Todate=11-13-2024
        url: `${APIConstants.ELECTRICAL_METER_STATUS}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&Parameters=${input.Parameters}&FromDate=${input.FromDate}&Todate=${input.ToDate}`
      }).then((res) => {
        // //console.log('Meter Data:', res);
        setIsLoading(false);
        const date = getLatestDate(res);
        // //console.log("Latest Date:", date.CreatedOn.replace("T", " "));
        setLatestDate(date?.CreatedOn?.replace("T", " "));
        if (res && res.length) {
          
          setMeterData(res);
        }
        // if (!res || res.length === 0) {
        //   setNoData(true);
        //   setMeterData([]);
        // } else {
        //   setNoData(false);
        // }
      }).catch((error) => {
        setIsLoading(false);
        setNoData(true);
        setMeterData([]);
        //console.error('Error fetching meter data:', error);
      });
    }
  };

  useEffect(() => {
    if (input ) {
    // //console.log("Input Data:", input);
    fetchMeterLive(input);
  }
  }, [input]);
  useEffect(() => {
    // if (input && input.MeterIds) {
    //   const timer = setTimeout(() => {
    //     //console.log("Input Data:", input);
    //     fetchMeterLive(input);
    //   }, 1000); // 1000 milliseconds = 1 second
  
    //   // Clear timeout if the component unmounts or input changes before timeout
    //   return () => clearTimeout(timer);
    // }
    // fetchMeterLive(input); 
    setSelectedMeter(selectedMeterIds)
  }, [selectedMeterIds]);


  const fetchNsFlow = (id) => {
    setIsLoading(true);
    // //console.log(meterCount) 

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_COVERTER_DETAILS}?ConverterID=${id}`
    }).then((res) => {
      // //console.log("Converter :", res);

      if(res&&res.length>0){
        if(defaultLoad){
          setSelectedMeterIds(res.map(meter => meter.meterid))
          localStorage.setItem("MeterStatusSelectedMeterIds", res.map(meter => meter.meterid));
          setDefaultLoad(false)
        }
        setNsFlowConverterList(res); 
        if (meterCount==0) {
          setMeterCount(2);
        }
      } else{
        
        setNsFlowConverterList([]); 
      }
      setIsLoading(false);

      if (!res || res.length === 0) {
        setNoData(true);
      } else {
        setNoData(false);
      }
      // setTimeout(() => {
      // }, 3000);
    }).catch((error) => {
      setIsLoading(false);
      setNoData(true);
      //console.error('Error fetching converter flow:', error);
    });
  };



  useEffect(() => {
    return () => {
      setIsLoading(false);
      setNoData(false);
      // setMeterData([]);
    }; 
  }, [converterGroupId,sectionId,selectedMeterIds]);



  useEffect(() => {
    if (converterGroupId&&sectionId==1) {
      fetchNsFlow(converterGroupId);
    }else if(converterGroupId&&sectionId==2){
      fetchGroupMeter(converterGroupId);
    }
    
  }, [converterGroupId]);
  



  const fetchGroupMeter = (id) => {
    setIsLoading(true);
    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${id}&Module=1`
    }).then((res) => {
      // //console.log("Meter list :", res);
      if(res&&res.length>0){
        setGroupMeterList(res);
        
        setIsLoading(false);
      }else{
        setGroupMeterList([]);

      }
    }).catch((error) => {
      setIsLoading(false);
      // //console.error('Error fetching group meter data:', error);
    });
  };

  useEffect(() => {
    // //console.log('Section List :', flowSectionList);
  }, [flowSectionList]);
  useEffect(() => {
 localStorage.setItem("sectionId", 1);
     localStorage.setItem("converterGroupId", 1);
     return () => {
       console.log("Component unmounted — clearing localStorage");
       localStorage.removeItem("sectionId");
           localStorage.removeItem("converterGroupId");
    };
  }, []);

  useEffect(() => {
    // //console.log('Converter List :', flowConverterList);
  }, [flowConverterList]);




  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_FLOW_SECTION_MASTER_DETAILS, 
    }).then((res) => {
      // //console.log("Master details :", res)
      if(res&&res.length>0){
        setFlowSectionList(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS,
    }).then((res) => {
      // //console.log("Converter details :", res)
      if(res&&res.length>0){
        setFlowConverterList(res);
      }
    });

  

    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.ELECTRICAL_PARAMETER_DETAILS,
    }).then((res) => {
      // //console.log("Parameter List :", res)
      if(res&&res.length>0){
        setParameterList(res);
        localStorage.setItem("parameterList", JSON.stringify(res));
      }
        
    });

  }, [])

  useEffect(() => {
     if(sectionId==2){
      makeRequest({  
        type: APIConstants.POST, 
        url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
      }).then((res) => {
        // //console.log(res)
        setMeterCount(2);
        if(res&&res.length>0){
          function replaceKeys(arr) {
            return arr.map(item => ({
                sitE_ID: item.groupID,
                sitename: item.department
            })); 
        }
          // //console.log(replaceKeys(res));
          setFlowGroupDetailList(res);
        }
      });
    }
  }, [sectionId]);

  // useEffect(() => {
  //   if (selectedValues.length === 0) {
  //     setSelectedValues(defaultParameters);
  //   }
  // }, [selectedValues]);


  const handleChangeSection = (changedValues) => {
    // setReport([])
    setSectionId(changedValues);
    localStorage.setItem("sectionId", changedValues);
    localStorage.setItem("MeterStatusSelectedMeterIds", '');
    localStorage.setItem("converterGroupId", '');

    setSelectedMeterIds([]);
    setConverterGroupId(null);
    setSubmitClicked(false)
    if (changedValues) {
      setSectionError("");
    }
  };

  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     setSkip(false);
  //   }, 3000);
  //   return () => clearTimeout(timeoutId);
  // }, []);


  const handleChangeConverterGroup = (changedValues) => {
    // //console.log(changedValues)
    // setReport([])
    // setMeterData([]);
    setConverterGroupId(changedValues);
    localStorage.setItem("converterGroupId", changedValues);
    localStorage.setItem("MeterStatusSelectedMeterIds", '');
    setSubmitClicked(false)
    setSelectedMeterIds([]);
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    localStorage.setItem("MeterStatusSelectedMeterIds", selectedValues);

    if (!selectedValues.length) {
      setSubmitClicked(false)
    }
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {

    if (values.length > 4) {
      values = values.slice(0, 4);
    }
    if (values.length > 4) {
      // //console.log(values)
      setParameterLenght('Cannot select more than 4 values')
    } else {
      setParameterLenght('')
    }

    if (values.length === 5) {
      setParaError("You can only select up to 4 parameters.");
    } else {
      setParaError("");
    }

    setSelectedValues(values);
    setSubmitClicked(false);
  };


  // //console.log(selectedMeterIds)
  // //console.log(selectedMeter)
  const setInputData = () => {
    // //console.log(selectedMeter)
    // //console.log(selectedMeterIds)
    const id = localStorage.getItem("MeterStatusSelectedMeterIds");
    // console.log(id)
    const ids = id;
    const currentDate = new Date();
    const { from, to } = calculateDateRangeFromDate(currentDate, 5, 2);

    // //console.log(selectedValues)
    const parameterList= localStorage.getItem("parameterList")?JSON.parse(localStorage.getItem("parameterList")):[];
    // console.log(selectedMeterIds.join(','))
    
    const selectedParameterNames = selectedValues.map((value) => {
        const parameter = parameterList.find((param) => param.parameterid === value);
        return parameter ? parameter.parametername : null;
    }).filter((name) => name);
  //   //console.log(selectedParameterNames)

  //  //console.log(parameterList) 
    if (!selectedValues.includes("IAVG") && !selectedParameterNames.includes("IAVG")) {
        // selectedParameterNames.push("IAVG");
        setSelected(false);
    }else{
      setSelected(true); 
    }
    // //console.log(selectedParameterNames)
    // //console.log(selectedValues)
    const sectionId = localStorage.getItem("sectionId");
    const converterGroupId = localStorage.getItem("converterGroupId");

    const inputData = {
        SectionID: Number(sectionId)||1,
        ConverterorGroupID: Number(converterGroupId)||1,
        MeterIds: selectedMeterIds.join(','),
        FromDate: from,
        ToDate: to,
        // Parameters: selectedValues.length<=1?[ 'VLLAvg', 'IAVG', 'kWhTotal', 'KWT' ].join(','):selectedParameterNames.join(','),
        Parameters: selectedParameterNames.join(','),
        // IAvg: selectedValues.includes("IAVG") ? "IAVG" : "", 
    };

    // //console.log("Input Data:", inputData);
    setInput(inputData);
};
useEffect(() => {
setInputData()
},[defaultLoad])

 
  const validateInput = (value, label) => {
    const error = !value || (Array.isArray(value) && value.length === 0) ? `Please Select ${label}` : "";
    return error;
  };


  const handleSubmit = async () => {
    setSubmitClicked(true);
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds?.length, "Meter");
    const paraError = validateInput(selectedValues?.length, "Parameter");
    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    // //console.log(sectionError, converterError, meterError, paraError)

    if (!sectionError && !converterError && !meterError && !paraError && !parameterLenght) {
      setInputData();
      onClose();
    }
  };

  // useEffect(() => {
  //   //console.log('MeterData :', MeterData);
  // }, [MeterData]);
  // //console.log(converterGroupId)


  useEffect(() => {
    // //console.log("Selected Meter IDs :", selectedMeterIds);
    // //console.log(MeterData)
    // //console.log(selectedMeterIds)
    if (MeterData?.length) {
      const selectedMeterData = MeterData.filter(item =>
        sectionId===1?
        selectedMeterIds?.includes(String(item.MeterId)|| item.MeterId):
        selectedMeterIds?.includes(item.AutoID)
      );
      // //console.log('Filtered Report :', selectedMeterData);
      setReport(selectedMeterData);
    }
  }, [MeterData]);

  return (
    <div className="relative p-0 md:p-4 overflow-x-hidden" >
      <div className="sm:flex-col justify-between items-center md:flex md:flex-row">
          <div className="text-xl md:text-3xl w-full md:w-fit flex">
          <p className={` pb-0 text-center font-[500]  ml-3 tracking-[1px] dark ${isdarkMode ? 'darkfont' : 'whitemode'} `}>METER STATUS</p>
          </div> 
          <div className="md:flex flex-col px-4 md:p-0 gap-2 md:flex-row ">
            <div className={` ${isdarkMode? "text-white bg-slate-400":'text-black bg-slate-100'} border rounded-lg p-2 px-4 flex items-center justify-center mr-2 font-semibold`} >
              Last Poll Date : 
              {latestDate}
            </div>
            <div className="flex justify-evenly mt-2 md:mt-0">
              <Tag className="animated-tag w-24 text-lg">
                        <EnvironmentOutlined className="mr-1" />
                        Live
                      </Tag>
         <Button role="primary" size="large" 
          className="flex justify-center items-center secondary-btn"
          style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}
           onClick={()=>setOpen(!open)}>
         <FilterOutlined /> Filter
         </Button>

            </div>
          </div>
      </div>
      {/* {isLoading && report && report.length ? (
        <Skeleton active paragraph={{ rows: 6 }} />
      ) 
      // : noData ? (
      //   <div className="text-center">No Data Available</div>
      // ) 
      : (
        <>
          
        </>
      )} */}
      <ElectricalMeterGrid open={open} setOpen={setOpen} sectionId={sectionId} converterGroupId={converterGroupId} report={report} selected={selected} setSelected={setSelected} />

       

      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
        className={`  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}

      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={flowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            selectedValues={sectionId}

          />
          <small className="text-red-500 font-bold ml-[150px]">{sectionError}</small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId == 1 ? flowConverterList : flowGroupDetailList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
            selectedValues={converterGroupId}
          />
          <small className="text-red-500 font-bold ml-[150px]">{converterError}</small>
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsFlowConverterList
                : GroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterid"}
            valueKey={sectionId === 1 ? "meterid" : "meterid"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />

          <small className="text-red-500 font-bold ml-[150px]">{meterError}</small>
          <SteamTreeSelectCustom
            label="Parameter:" 
            data={parameterList}
            idKey="parameterid"
            nameKey="parametername"
            valueKey="parameterid"
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onSelect={handleTreeChange}
            disabled={selectedValues.length >= 4}
          />
          {paraError && (
            <small className="text-red-500 font-bold ml-[150px]">{paraError} {parameterLenght} </small>
          )}
        </div>
        <div className="flex justify-center mt-4">

                     <Button
                       type= {isdarkMode? "":'primary'}
                       onClick={() => {
                         handleSubmit();
                       }}
                     >
                       Search
                     </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default MeterStatus;